export default "__VITE_ASSET__D$SpiX5D__"